import { logger } from '../../helpers/logger/logger'

export function editUrl(WS_URL) {
  if (WS_URL.includes('orbitalgaming.com')) {
    console.clear()
    logger.isEnabled = false
  }

  const hostname = window.location.hostname
  if (hostname === 'localhost') {
    WS_URL = 'wss://dev.orbitalgaming.io/wsbridge/v1/game/orbital.cyberdice'
  } else if (WS_URL === "{{SERVER_WS_URL}}") {
    WS_URL = `wss://${hostname}/wsbridge/v1/game/orbital.cyberdice`
  }
  return WS_URL
}

